//Автоопределение buildType
const buildType =
    window.location.hostname === 'localhost'
        ? 'LOCAL'
        : window.location.hostname === 'app.dataheroes.pro'
        ? 'PRODUCTION'
        : 'TEST'

//const buildType = process.env.VUE_APP_BUILD_TYPE
const reportStaffIds = buildType === 'PRODUCTION' ? [51, 61, 62] : [8, 11]
const excelActivationId = buildType === 'PRODUCTION' ? 3611 : 6799
const uploadActivationId = buildType === 'PRODUCTION' ? 4080 : 6846
const frontendEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:8080'
        : buildType === 'PRODUCTION'
        ? 'https://app.dataheroes.pro'
        : 'https://app.crmmsk.ru'
const apiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3000/api'
        : buildType === 'PRODUCTION'
        ? 'https://bff.dataheroes.pro/api'
        : 'https://bff.crmmsk.ru/api'
const adminApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3005'
        : buildType === 'PRODUCTION'
        ? 'https://admin-backend.dataheroes.pro'
        : 'https://admin-backend.crmmsk.ru'
const chatEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:5173'
        : buildType === 'PRODUCTION'
        ? 'https://dh-chat.dataheroes.pro'
        : 'https://test-dh-chat.dataheroes.pro'
const updaterApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3000/api'
        : buildType === 'PRODUCTION'
        ? 'https://update.dataheroes.pro/api'
        : 'https://update.crmmsk.ru/api'
const authApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3001/api'
        : buildType === 'PRODUCTION'
        ? 'https://bff.dataheroes.pro/api'
        : 'https://bff.crmmsk.ru/api'
export default {
    excelActivationId,
    uploadActivationId,
    reportStaffIds,
    buildType,
    waitThaiEnabled: buildType !== 'PRODUCTION',
    frontendEndpoint,
    apiEndpoint,
    adminApiEndpoint,
    chatEndpoint,
    updaterApiEndpoint,
    mqUrl: getMqUrl(),
    yMId: getYMId(),
    authApiEndpoint,
    adminApiEndopint: 'admin-backend.dataheroes.pro',
    amoCrmClientId:
        buildType === 'PRODUCTION'
            ? '3af37da7-bfbc-4a15-a4f0-29d757ad66b0'
            : 'be342937-0271-45c2-8507-dca06616c56a',
    zmClientId: buildType !== 'LOCAL' ? 'g3ed2ca22a9c6e0546b04e0b95b379' : 'gccc81de8d34384de0fc8c78c75d7e',
    zmConsumerKey: buildType !== 'LOCAL' ? 'f5e28444ee' : 'ca0a5f6d87',
    zmRedirectUri:
        buildType !== 'LOCAL' ? 'https://app.crmmsk.ru/OAuthLogin' : 'http://localhost:8080/OAuthLogin',
    disabledConnectorsTypes:
        buildType === 'PRODUCTION' ? ['alfa', 'planfact', 'zenmoney'] : ['alfa', 'planfact', 'zenmoney'],
    disabledDashboardsIds: buildType === 'PRODUCTION' ? ['outflow', 'attendance'] : ['outflow', 'attendance'],
    disabledSettings: { yClients: ['group', 'division'] },
    /** Тестовый ряд для графика «Прирост подписчиков» (только monthsDynamicsData). Ещё: ?chartMock=1 в URL */
    subscribersGrowthChartMock: false,
    yClientSimpleAuth: true, //Упрощенная авторизация yClients
    idleReloadTimeout: 60, //Minutes
    wsUrl: getWsUrl(),
    audienceWithReturnAfterVar: buildType === 'PRODUCTION' ? [708] : [3931],
    botYcAvailable: ['XL7CAR0RN', 'PBGXYGSEA'],
    adminsWhitelist: [
        'google-oauth2|103524613464469136207',
        'auth0|JTL-Xi4vzTXfbwTuIEF6_',
        'google-oauth2|106448966005337154243',
        'google-oauth2|111747802967162964419',
        'google-oauth2|112331075346786769506',
        'google-oauth2|115772460460441863064',
        'auth0|61b8e0ba9397e6006af6e557',
        'auth0|KXOuvv47jMzQaP0NMXG8o',
        'google-oauth2|104152221588238449234',
        'auth0|-vC_3_IHpkYuK9UDp91xn',
        'google-oauth2|116265841278486246844',
        'google-oauth2|106212038968126676728',
        'google-oauth2|103654676938763064226',
        'auth0|_KomYIgegHln9AShSzlde',
        'auth0|TSdF8ldOhnLJvyimYU0TT',
        'auth0|pZwaFF5u-wXxLtGVodj4d',
        'google-oauth2|102027286731767220713',
        'auth0|uoY16A1cgLHMiJHdO4S1U',
        'auth0|LZKTFm-eZdO-vQ_bJXSmv',
        'auth0|Pr-yAqoGybmWixlvOsM8-',
        'google-oauth2|110335629880405454179',
        'auth0|5Dt0L0Wou67C0yBgSUMAQ',
        'auth0|mQX7liSLMcVw2I4HHtRop',
        'auth0|ksfV0e2kSUwAwnvqVTsKv',
        'google-oauth2|105973164533268684809',
        'google-oauth2|115326652418750839277',
        'google-oauth2|116791059376520238550',
        'google-oauth2|112947983865517618451',
        'google-oauth2|114458797360898224800',
        'auth0|hZBiNLLSWlbMIZfdYmIgG',
        'auth0|vSWYp8RG_eLpAwNwrNrsf',
        'google-oauth2|116576350167571712900',
        'auth0|Hjo1y1TZGcw1d5QfCVYSj',
        'auth0|aT7jK6_nA2DqfVPp5bMTB',
        'auth0|yX3FC_44t2eFUzF_f03pP',
        'auth0|JbZyD_LcI5QmZACMpVWfF',
        'auth0|z8cuWrDLVdhUVsLzvkxta',
        'google-oauth2|108125210029764065147',
    ],
    testerEmails: [],
    marketplaceModulesIds: {
        'LOCAL': {
            salesTraining: '56',
            beautyAutopilot: '53',
            crmSettings: '52',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '55',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '58',
            dhChat: 'dhChat',
            diagnostics: '60',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '65',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
        'TEST': {
            salesTraining: '56',
            beautyAutopilot: '53',
            crmSettings: '52',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '55',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '58',
            dhChat: 'dhChat',
            diagnostics: '60',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '65',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
        'PRODUCTION': {
            salesTraining: '46',
            beautyAutopilot: '42',
            crmSettings: '47',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '45',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '44',
            dhChat: 'dhChat',
            diagnostics: '48',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '50',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
    },
}

function getWsUrl() {
    if (buildType === 'PRODUCTION') {
        return 'https://ws.dataheroes.pro/'
    } else {
        return 'https://ws.crmmsk.ru/'
    }
}
function getMqUrl() {
    if (buildType === 'PRODUCTION') {
        return 'https://mq.dataheroes.pro'
    } else {
        return 'https://mq.crmmsk.ru'
    }
}

// Идентификатор счётчика Яндекс.Метрики.
// PRODUCTION (app.dataheroes.pro) — прод-счётчик; остальное (тест/local) — тестовый.
function getYMId() {
    if (buildType === 'PRODUCTION') {
        return 90138959
    } else {
        return 110147856
    }
}